class CarBadge {
    private title: string;
    readonly carBrands: { [key: string]: string };

    constructor(title: string) {
        this.title = title.toLowerCase();
        this.carBrands = {
            'bmw': '../../storage/marks/bmw.png',
            'audi': '../../storage/marks/audi.png',
            'mercedes': '../../storage/marks/mercedes.png',
            'toyota': '../../storage/marks/toyota.png',
            'nissan': '../../storage/marks/nissan.png',
            'volkswagen': '../../storage/marks/volkswagen.png',
            'mazda': '../../storage/marks/mazda.png',
            'honda': '../../storage/marks/honda.png',
            'renault':'../../storage/marks/renault.png',
            'romeo': '../../storage/marks/alpha_romeo.png',
            'porsche': '../../storage/marks/porsche.png',
            'ford': '../../storage/marks/ford.png',
            'dodge': '../../storage/marks/dodge.png',
            'ferrari': '../../storage/marks/ferrari.png',
            'lexus': '../../storage/marks/lexus.png',
            'lamborghini': '../../storage/marks/lamborghini.png',
            'suzuki': '../../storage/marks/suzuki.png',
            'skoda': '../../storage/marks/skoda.png',
            'chevrolet': '../../storage/marks/chevrolet.png',
            'maserati': '../../storage/marks/maserati.png',
            'mclaren': '../../storage/marks/mclaren.png',
            'subaru': '../../storage/marks/subaru.png',
            'chery': '../../storage/marks/chery.png',
            'zeekr': '../../storage/marks/zeekr.png',
            'geely': '../../storage/marks/geely.png',
            'bentley': '../../storage/marks/bentley.png',
            'ibishu': '../../storage/marks/ibishu.png',
            'gavril': '../../storage/marks/gavril.png',
            'hirochi': '../../storage/marks/hirochi.png',
            'cadillac': '../../storage/marks/cadillac.png',
            'fiat': '../../storage/marks/fiat.png',
            'volvo': '../../storage/marks/volvo.png',
            'kia': '../../storage/marks/kia.png',
            'koenigsegg': '../../storage/marks/koenigsegg.png',
            'etk': '../../storage/marks/etk.png',
            'dacia': '../../storage/marks/dacia.png',
            'infiniti': '../../storage/marks/infiniti.png',
            'lada': '../../storage/marks/lada.png',
            'mitsubishi': '../../storage/marks/mitsubishi.png',
            'peugeot': '../../storage/marks/peugeot.png',
            'rover': '../../storage/marks/landrover.png',
        };
    }

    public findCarBrand(): string | null {
        for (const brand in this.carBrands) {
            if (this.title.includes(brand)) {
                return this.createBadge(brand);
            }
        }
        return null;
    }

    private createBadge(brand: string): string {
        return `
            <div class="badge-large me-2 mb-2 d-flex align-items-center rounded position-relative">
                <img src="${this.carBrands[brand]}" class="mark-icon" alt="${brand}">
                <span class="text-black fw-semibold ms-1" style="margin-top: 2px">${brand.charAt(0).toUpperCase() + brand.slice(1)}</span>
                <a href="/search?query=${brand}&page=1" class="position-absolute top-0 start-0 w-100 h-100"></a>
            </div>
        `;
    }
}

export default CarBadge